import React from "react";
import "./Creative_ways.css";
import CommonHeadingAfterLine from "../../Common-Component/CommonHeadingAfterLine/CommonHeadingAfterLine";
import Orange_Round_Arrow_Btn from "../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import Shop_specialty_business_cards from "../../Common-Component/Shop_specialty_business_cards/Shop_specialty_business_cards";
import Creative_ways_cards from "../../Common-Component/Creative_ways_cards/Creative_ways_cards";

function Creative_ways() {
  return (
    <section className="Creative_ways">
      <div className="custom_container">
        <CommonHeadingAfterLine
          headingText={"Creative ways to use your cards"}
        />
        <div className="Creative_ways_heading_holder">
          <div className="text_holder">
            <p>
              Are you searching for something particular? <br />
              Explore these popular templates tailored for leading industries!
            </p>
          </div>

          <Orange_Round_Arrow_Btn
            btn_name={"Explore Business Card Templates"}
          />
        </div>

        <div className="Creative_ways_cards_holder">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-4 col-sm-6 col-6 mb-3">
              <Creative_ways_cards />
            </div>

            <div className="col-lg-8 col-md-8 col-sm-6 col-12 mb-3">
              <div className="row">
                <div className="col-md-6 col-6 mb-3">
                  <Creative_ways_cards anotherClass={"custmue_card"} />
                </div>

                <div className="col-md-6 col-6 mb-3">
                  <Creative_ways_cards anotherClass={"custmue_card"} />
                </div>

                <div className="col-md-6 col-6 mb-3">
                  <Creative_ways_cards anotherClass={"custmue_card"}/>
                </div>

                <div className="col-md-6 col-6 mb-3">
                  <Creative_ways_cards anotherClass={"custmue_card"}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Creative_ways;
